import React from 'react';
import Table from '../shared/table/Table';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';

/**
 * Component to display the table component for the message responses
 * @param {object} props
 */
const MessagesMessageViewTable = (props) => {
  const { details, filters } = props;
  // Generate the table headings for the table
  const tableHeadings = [
    {
      isSortable: true,
      sortBy: 'device',
      display: (
        <FormattedMessage
          id="messages.messageDetailsTableDeviceHeading"
          defaultMessage="Device"
          description="Button to set sort by the ID column"
        />
      ),
    },
    {
      isSortable: true,
      sortBy: 'status',
      display: (
        <FormattedMessage
          id="messages.messageDetailsTableStatusHeading"
          defaultMessage="Status"
          description="Button to set sort by the message status"
        />
      ),
    },
    {
      isSortable: true,
      sortBy: 'delivered',
      display: (
        <FormattedMessage
          id="messages.messageDetailsTableDeliveredHeading"
          defaultMessage="Delivered"
          description="Button to set sort by the time the message was delivered"
        />
      ),
    },
    {
      isSortable: true,
      sortBy: 'acknowledged',
      display: (
        <FormattedMessage
          id="messages.messageDetailsTableAcknowledgedHeading"
          defaultMessage="Acknowledged"
          description="Button to set sort by the time the message was acknowledged"
        />
      ),
    },
  ];

  /**
   * Function to generate the data to display in the table
   * @returns {object} - The sorted and filtered table of responses
   */
  function createTableData() {
    let detailDisplay;
    // First check to make sure there's something to display
    if (details && details.length > 0) {
      let delivered = [];
      // Create an array of just the items marked delivered if the delivered filter is true, if it's false, the array will be empty
      if (filters.delivered) {
        delivered = details.filter((item) => item.msg_status === 'Delivered');
      }
      let undelivered = [];
      if (filters.undelivered) {
        undelivered = details.filter(
          (item) => item.msg_status === 'Undelivered'
        );
      }
      let acknowledged = [];
      if (filters.acknowledged) {
        acknowledged = details.filter(
          (item) => item.msg_status === 'Acknowledged'
        );
      }
      // Take the arrays of the delivered, undelivered, and acknowledged items and combine them. If any of the filters are set then those results will be empty and not show up in the results
      let filteredDetails = [...delivered, ...undelivered, ...acknowledged];

      let searchedDetails = [];
      // Take the array and filter based on the text entered in the search bar.
      if (filters.detailsSearch) {
        searchedDetails = filteredDetails.filter((item) => {
          // Make the device name uppercase for case insensitivity
          const device = item.device.toUpperCase();
          // filter based off the includes() value with the entered text (also switched to uppercase) as the filter parameter
          return device.includes(filters.detailsSearch.toUpperCase());
        });
      } else {
        searchedDetails = filteredDetails;
      }

      const tableData = [];
      // Map over the filtered results
      searchedDetails.map((item) => {
        let deliveredTime = 'N/A';
        let deliveredSortTime = '0';
        // Check to see if there's an unacknowledged time (which actually means delivered) and create the formatted date and time for it
        if (item.unacknowledged_time) {
          deliveredTime = (
            <React.Fragment>
              <FormattedDate
                value={new Date(item.unacknowledged_time)}
                year="numeric"
                month="2-digit"
                day="2-digit"
              />
              <span className="margin-left-10">
                <FormattedTime
                  value={new Date(item.unacknowledged_time)}
                  timeZone="UTC"
                />
              </span>
            </React.Fragment>
          );
          deliveredSortTime = item.unacknowledged_time;
        }

        let acknowledgedTime = 'N/A';
        let acknowledgedSortTime = '0';
        if (item.acknowledged_time) {
          acknowledgedTime = (
            <React.Fragment>
              <FormattedDate
                value={new Date(item.acknowledged_time)}
                year="numeric"
                month="2-digit"
                day="2-digit"
              />
              <span className="margin-left-10">
                <FormattedTime
                  value={new Date(item.acknowledged_time)}
                  timeZone="UTC"
                />
              </span>
            </React.Fragment>
          );
          acknowledgedSortTime = item.acknowledged_time;
        }
        // add to the results in the format for the table component to use to generate the sortable table
        tableData.push({
          device: {
            sortBy: item.device,
            display: item.device,
          },
          status: {
            sortBy: item.msg_status,
            display: item.msg_status,
          },
          delivered: {
            sortBy: deliveredSortTime,
            display: deliveredTime,
          },
          acknowledged: {
            sortBy: acknowledgedSortTime,
            display: acknowledgedTime,
          },
        });
        return '';
      });
      // generate the table
      detailDisplay = (
        <Table
          hasTableHead={true}
          tableData={tableData}
          tableHeadings={tableHeadings}
          tableStyles="table__message-list-table"
          rowStyles="table__row"
          tableHeadStyles="table__header"
          sortParam="device"
          data-test="component-details-table"
        />
      );
    } else {
      detailDisplay = '';
    }
    return detailDisplay;
  }
  // return the table
  return <React.Fragment>{createTableData()}</React.Fragment>;
};
export default MessagesMessageViewTable;
